'use client'

import { Button, Cell, Dialog, Image, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useImageAssetsUrl } from '@marketplace-web/shared/assets'

import { CATALOG_URL } from '../constants/routes'

const ErrorModal = () => {
  const translate = useTranslate('item.error')

  const assetUrl = useImageAssetsUrl()

  return (
    <Dialog show closeOnOverlay={false} testId="item-page-error-modal">
      <Cell>
        <div className="u-flexbox u-justify-content-center">
          <Image src={assetUrl('exclamation-red.svg')} size={Image.Size.Large} />
        </div>
        <Spacer size={Spacer.Size.Large} />
        <Text
          text={translate('title')}
          width={Text.Width.Parent}
          alignment={Text.Alignment.Center}
          type={Text.Type.Heading}
          as="h2"
        />
        <Spacer size={Spacer.Size.Large} />
        <Text
          text={translate('body')}
          width={Text.Width.Parent}
          alignment={Text.Alignment.Center}
          type={Text.Type.Title}
          as="p"
        />
      </Cell>
      <Cell>
        <Button text={translate('cta')} url={CATALOG_URL} styling={Button.Styling.Filled} />
      </Cell>
    </Dialog>
  )
}

export default ErrorModal
